module.exports = __webpack_public_path__ + "img/icon-vehicle-type-n3.9025cf89.svg";